module.exports = __webpack_public_path__ + "img/TZS09422.a8713de9.jpeg";